/**
 * Frontend convenience copy of the project-mailbox validator
 * (PROJECT-MAILBOX-EMAIL-2026-09-01 D22/D23, T494). The BACKEND validator in
 * lambda/layer/nodejs/projectMailbox.js is the guard - this exists so the form
 * can refuse before a round trip, and it applies the same rules: a single
 * plain @themigrationexperts.com address, exact domain match on everything
 * after the final @, no display names, separators, whitespace or CR/LF.
 */

export const MAILBOX_DOMAIN = 'themigrationexperts.com';

export function validateProjectMailbox(address) {
    if (typeof address !== 'string' || address.trim() === '') {
        return 'A project mailbox address is required';
    }
    if (/[\s,;<>"()]/.test(address)) {
        return 'Enter a single plain email address - no spaces, commas, semicolons or display name';
    }
    if (address.length > 254) {
        return 'Enter a valid email address';
    }
    const at = address.lastIndexOf('@');
    if (at <= 0 || at === address.length - 1) {
        return 'Enter a valid email address';
    }
    const local = address.slice(0, at);
    const domain = address.slice(at + 1).toLowerCase();
    if (domain !== MAILBOX_DOMAIN) {
        return `The project mailbox must be an @${MAILBOX_DOMAIN} address`;
    }
    if (!/^[A-Za-z0-9._%+-]+$/.test(local)) {
        return 'Enter a valid email address';
    }
    return null;
}
